import React from 'react';

import DataReportEditor from '../components/data-report/editor';

class DataReportPage extends React.Component{

	render(){
		return (
			<div style={{ margin: 16 }}>
				<DataReportEditor />
			</div>
		)
	}

}

export default DataReportPage;


// WEBPACK FOOTER //
// ./src/containers/data-report-editor-page.js